import React from "react";
import styles from "./StickyContact.module.css";
import PhoneIcon from "@mui/icons-material/Phone";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

function StickyContact() {
  return (
    <div>
      <div id="mySidenav" className={`${styles.sidenav}`}>
        <div className={`${styles.about}`}>
          <h6 style={{ lineHeight: "1.5" }}>
            <strong> Contact Now:</strong> <br /> +91 7030962626
          </h6>
          <h6 className="mb-0">
            <PhoneIcon />
          </h6>
        </div>
      </div>
      <div className={`${styles.container_top}`}>
        <a href="/" className={`${styles.top}`} title="Back To Top">
          <ExpandLessIcon />
        </a>
      </div>
    </div>
  );
}

export default StickyContact;
